module.exports = __webpack_public_path__ + "img/icon-coupon.1225116d.svg";